import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { PeopleIndexMultiSelectComponent } from './people-index-multiselect.component';
import { PeopleIndexSelectComponent } from './people-index-select.component';
import { TableResponsiveModule } from '../table-responsive/table-responsive.module';
import { DialogContainerModule } from '../../dialog-container/dialog-container.module';
import { PeopleMultiSelectService } from './people-service';

@NgModule({
    declarations: [
        PeopleIndexMultiSelectComponent,
        PeopleIndexSelectComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        FlexLayoutModule,
        TableResponsiveModule,
        DialogContainerModule
    ],
    providers: [
        PeopleMultiSelectService
    ],
    exports: [
        PeopleIndexMultiSelectComponent,
        PeopleIndexSelectComponent,
    ]
})
export class PeopleMultiSelectModule { } 